import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } 		from './app.component';
import { ProgramDiscoveryPageComponent } from './program-discovery-page/program-discovery-page.component';
import { environment } from '../environments/environment';

const appRoutes: Routes = [
  {path: 'index.cfm', component: ProgramDiscoveryPageComponent},
  {path: '', redirectTo: 'index.cfm', pathMatch: 'full'}
];

@NgModule({
  imports: [ RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' }) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {}

export const routingComponents = [ProgramDiscoveryPageComponent];